export type IStateStorage = {
    state: 'initializing' | 'validating' | 'solving' | 'solved' | 'error';
    solution: string;
    rate: number;
    errorMsg: string;
    errorId: string
}
export type StateKey = keyof IStateStorage;
export type StateKeysOrAll = StateKey[] | StateKey | '*';
export type StateValue = IStateStorage[StateKey];
export type Change = { key: StateKey, value: StateValue, oldValue: StateValue };
export type Callback = (changes: Change[]) => void;

export type IStateView = Readonly<IStateStorage>
export type IState = IStateView & {
    setError: (id: string, error: unknown) => PromiseLike<void>;
    requestValidation: () => Promise<void>;
    onChanges: (keys: StateKeysOrAll, callback: Callback) => (() => void);
}
export type StateSubscription = {
    keys: StateKey[];
    callback: Callback;
}

export const KEYS = ['state', 'solution', 'rate', 'errorMsg', 'errorId'] as const satisfies StateKey[];
export function resolveKeys(keys: StateKeysOrAll): StateKey[] {
    if (keys === '*') {
        keys = [...KEYS];
    } else if (typeof keys === 'string' && KEYS.includes(keys)) {
        keys = [keys as StateKey];
    } else if (Array.isArray(keys)) {
        keys = keys.filter(key => KEYS.includes(key)) as StateKey[];
    }
    if (!Array.isArray(keys) || keys.length === 0) {
        throw new Error("Invalid keys provided for subscription");
    }
    return Array.from(new Set(keys));
}
export function isValidStateKey(key: string): key is StateKey {
    return KEYS.includes(key as StateKey);
}
export function createView(state: IStateStorage | IStateView): IStateView {
    return Object.freeze({
        get state() { return  state.state },
        get solution() { return state.solution},
        get rate() { return  state.rate },
        get errorMsg() { return  state.errorMsg },
        get errorId() { return  state.errorId },
    });
}